import * as Sentry from '@sentry/react';
import axios from 'axios';

Sentry.init({
  dsn: 'https://c90babaa62ae891224179a558c7dcc8d@o4509917521379328.ingest.de.sentry.io/4509917544120400',
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  release: import.meta.env.VITE_APP_VERSION,
  environment: import.meta.env.MODE,
  ignoreErrors: [
    // Outlook SafeLinks pre-scanner (Microsoft) probes promise behavior
    // in a way that throws this signature. Not a real bug in our code.
    /^Object Not Found Matching Id:/,
  ],
  denyUrls: [
    // Pinterest conversion tracking script — periodic load failures from
    // CDN issues, network blocking, or ad blockers.
    /ct\.pinterest\.com/,
  ],
  beforeSend(event, hint) {
    const error = hint?.originalException;
    if (axios.isAxiosError(error)) {
      const { config, response } = error;
      const fullUrl = config?.baseURL
        ? `${config.baseURL}${config.url ?? ''}`
        : config?.url;
      // Replace UUIDs in the path with :uuid to keep tag cardinality bounded.
      // The raw URL with the actual UUIDs stays in contexts.request.
      const normalizedUrl = config?.url?.replace(
        /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
        '/:uuid',
      );
      event.tags = {
        ...event.tags,
        'http.url': normalizedUrl,
        'http.method': config?.method?.toUpperCase(),
        'http.status_code': String(response?.status ?? 'unknown'),
      };
      event.contexts = {
        ...event.contexts,
        request: {
          ...event.contexts?.request,
          url: fullUrl,
          method: config?.method?.toUpperCase(),
          status_code: response?.status,
        },
      };
    }
    // Stabilize Sentry grouping for invalid-offer errors. The explicit
    // captureException in session.mappers.ts already sets this fingerprint;
    // this catches the unhandled rejection that follows the throw, which
    // would otherwise group by the detailed (per-failure-mode) message.
    if (error instanceof Error && error.message.startsWith('Invalid offer:')) {
      event.fingerprint = ['invalid-offer'];
    }
    return event;
  },
});
